export default "__VITE_ASSET__9d12b398__"